<template>
  <div class="page-not-found">
    <img v-if="backgroundImage" :src="backgroundImage" />

    <div class="page-not-found__card">
      <span class="code">{{ code }}</span>
      <p v-html="message" />
    </div>

    <Modals />
  </div>
</template>
<script setup>
import {useLoader} from "@/js/Plugins/Loader.js";
import {useRoute, useRouter} from "vue-router";
import {computed, ref} from "vue";
import {useI18n} from "vue-i18n";
import Modals from "@/js/Components/Modal/Modals.vue";

const loader = useLoader();
const router = useRouter();
const route = useRoute();
const { t } = useI18n();
const code = ref(window.setup?.errorCode || (route ? route.params.pathMatch[0] : 404));
const message = ref(window.setup?.errorMessage || t('errors.404'));

loader.hide();

const backgroundImage = computed(() => {
  return window.setup?.login?.background_image;
})
</script>

<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.page-not-found {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: themeColor('neutral-100');
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__card {
    width: 100%;
    max-width: toRem(400);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: spacing(4);
    position: relative;
    z-index: 1;
    background-color: themeColor('base');
    border-radius: $border-radius-xl;

    .code {
      font-size: toRem(40);
      font-weight: $font-weight-semibold;
      text-transform: uppercase;
    }

    p {
      text-align: center;
      font-size: fontSize(20);
    }
  }
}
</style>